import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0  24 24" fill="none" {...props}>
        <Path
            fill={props.color ?? ds.colorValue.icon.primary}
            d="M13 12a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4ZM12 9.5A1.25 1.25 0 1 0 12 7a1.25 1.25 0 0 0 0 2.5Z"
        />
        <Path
            fill={props.color ?? ds.colorValue.icon.primary}
            fillRule="evenodd"
            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
            clipRule="evenodd"
        />
    </Svg>
);
export { SvgComponent as InfoWhiteIcon };
